/** Painel interno /dev — PT / EN / ES */
export const devTranslations = {
  pt: {
    'dev.permissions.title': 'Permissões de desenvolvedores',
    'dev.permissions.subtitle':
      'Cadastre devs, advogados ou outros perfis internos. O convite com link de senha é enviado por WhatsApp. CPF é opcional — a pessoa preenche no aceite do convite.',
    'dev.permissions.register_section': 'Cadastrar usuário',
    'dev.permissions.register_btn': 'Cadastrar usuário',
    'dev.permissions.role_preset': 'Perfil de acesso',
    'dev.permissions.role.developer': 'Desenvolvedor (acesso completo)',
    'dev.permissions.role.lawyer': 'Advogado (somente Contratos)',
    'dev.permissions.role.custom': 'Personalizado (ajuste permissões depois)',
    'dev.permissions.cpf': 'CPF',
    'dev.permissions.cpf_hint': 'Opcional. Se vazio, a pessoa informa o CPF ao aceitar o convite.',
    'dev.permissions.name': 'Nome completo *',
    'dev.permissions.name_placeholder': 'Ex.: Maria Silva',
    'dev.permissions.email': 'E-mail',
    'dev.permissions.email_placeholder': 'nome@empresa.com',
    'dev.permissions.phone': 'Telefone *',
    'dev.permissions.phone_placeholder': '(11) 99999-9999',
    'dev.permissions.cancel': 'Cancelar',
    'dev.permissions.no_edit_access':
      'Sem a ação "Permissões de outros desenvolvedores" no cargo interno — você pode ver a lista, mas não cadastrar aqui.',
    'dev.permissions.team_section': 'Equipe cadastrada ({count})',
    'dev.permissions.loading': 'Carregando…',
    'dev.permissions.empty':
      'Nenhum registro retornado. Confira o n8n (get + type all) para o CNPJ interno.',
    'dev.permissions.you': 'Você',
    'dev.permissions.status.active': 'Ativo',
    'dev.permissions.status.inactive': 'Inativo',
    'dev.permissions.role_label': 'Função:',
    'dev.permissions.edit': 'Editar permissões',
    'dev.permissions.perms': 'Permissões',
    'dev.permissions.dva_hint':
      'Controle DelivAI — {count} ações mapeadas às ferramentas do menu lateral.',
    'dev.permissions.license_ver': '{module} — ver',
    'dev.permissions.default_cargo': 'Dev DelivAI',
    'dev.permissions.load_error': 'Erro ao carregar colaboradores internos.',
    'dev.permissions.register_error': 'Erro ao cadastrar.',
    'dev.permissions.save_error': 'Erro ao salvar permissões.',
    'dev.permissions.invite_whatsapp':
      'Olá, {name}! Você foi cadastrado(a) na equipe DelivAI. Acesse o link abaixo para informar seu CPF e criar sua senha. Este link expira em 30 minutos.\n{link}',
    'dev.permissions.invite_sender': 'Convite equipe DelivAI (WhatsApp)',
    'dev.permissions.error.cpf_invalid_blank':
      'CPF inválido. Informe 11 dígitos ou deixe em branco para a pessoa preencher no convite.',
    'dev.permissions.error.cpf_invalid':
      'CPF inválido. Corrija o número ou deixe em branco.',
    'dev.permissions.error.name_required': 'Informe o nome completo.',
    'dev.permissions.error.phone_required': 'Informe o telefone com DDD (10 ou 11 dígitos).',
    'dev.prompts.title': 'Prompts do bot',
    'dev.prompts.subtitle':
      'Um template por nicho (delivery, clínica, etc.). Nome, endereço e cardápio de cada loja são concatenados automaticamente antes de enviar à IA — não crie prompt por empresa.',
    'dev.prompts.new': 'Novo template',
    'dev.prompts.list': 'Templates ({count})',
    'dev.prompts.list_empty': 'Nenhum registro. Crie um novo ou verifique o workflow n8n.',
    'dev.prompts.no_edit':
      'Sem permissão para editar. Você pode apenas visualizar.',
    'dev.prompts.edit': 'Editar template',
    'dev.prompts.create': 'Novo template',
    'dev.prompts.select': 'Selecione um template',
    'dev.prompts.niche': 'Nicho',
    'dev.prompts.niche_placeholder': 'ex.: delivery, clinica',
    'dev.prompts.niche_hint':
      'Slug compartilhado por todas as lojas do mesmo segmento. Ex.: oficina, delivery.',
    'dev.prompts.instructions': 'Instruções (regras globais do nicho)',
    'dev.prompts.instructions_hint':
      'Regras fixas do segmento. Idioma do cliente e dados da loja são injetados em runtime — não duplique por CNPJ.',
    'dev.prompts.body': 'Corpo do prompt (body_content)',
    'dev.prompts.version': 'Versão',
    'dev.prompts.active': 'Ativo',
    'dev.prompts.inactive_badge': 'inativo',
    'dev.prompts.metadata': 'metadata (JSON)',
    'dev.prompts.delete': 'Excluir',
    'dev.prompts.save': 'Salvar',
    'dev.prompts.create_btn': 'Criar',
    'dev.prompts.saving': 'Salvando…',
    'dev.prompts.load_error': 'Erro ao carregar templates.',
    'dev.prompts.niche_required': 'Informe o nicho (slug/categoria).',
    'dev.prompts.metadata_invalid': 'metadata deve ser um objeto JSON.',
    'dev.prompts.json_invalid': 'JSON inválido em metadata.',
    'dev.prompts.save_error': 'Erro ao salvar.',
    'dev.prompts.delete_error': 'Erro ao excluir.',
    'dev.prompts.created': 'Template criado.',
    'dev.prompts.saved': 'Alterações salvas.',
    'dev.prompts.deleted': 'Template excluído.',
    'dev.prompts.delete_title': 'Excluir template?',
    'dev.prompts.delete_message':
      'Esta ação remove o registro em prompt_templates. Não é possível desfazer.',
    'dev.prompts.no_nicho_label': '(sem nicho)',
    'dev.licenses.title': 'Licenças e valores exibidos ao cliente',
    'dev.licenses.subtitle':
      'O catálogo de preços vale para todas as lojas e é gravado em pay_types.license_catalog no CNPJ interno. Abaixo, o ajuste por CNPJ altera só aquele cliente.',
    'dev.licenses.global_section': 'Catálogo global (todas as lojas)',
    'dev.licenses.global_hint':
      'Abra cada categoria para editar dias e planos. Use Dias no PIX e Valor (centavos) em cada período.',
    'dev.licenses.loading_catalog': 'Carregando catálogo…',
    'dev.licenses.save_global': 'Salvar catálogo global',
    'dev.licenses.per_client_section': 'Ajuste por cliente',
    'dev.licenses.per_client_hint': 'Busca via get-customer; alterações via update-customer (dias, pay_types, módulos).',
    'dev.licenses.cnpj_label': 'CNPJ do cliente',
    'dev.licenses.search': 'Buscar',
    'dev.licenses.loading': 'Carregando…',
    'dev.licenses.client_fallback': 'Cliente',
    'dev.licenses.modules_section': 'Módulos da licença',
    'dev.licenses.modules_hint': 'Mesmos campos booleanos usados na sidebar e na tela de licença do cliente.',
    'dev.company.license_title': 'Licença',
    'dev.company.license_ask_days': 'Dias',
    'dev.company.license_days_7': '7 dias',
    'dev.company.license_days_30': '30 dias',
    'dev.company.license_days_180': '180 dias',
    'dev.company.license_days_365': '1 ano',
    'dev.company.license_ask_modules': 'Quais módulos ficam ativos?',
    'dev.company.license_continue': 'Continuar',
    'dev.company.license_turn_on': 'Ativar licença',
    'dev.company.license_cancel': 'Cancelar',
    'dev.company.license_days_invalid': 'Informe um número de dias maior que zero.',
    'dev.company.license_notes': 'Observações internas',
    'dev.company.license_notes_ph': 'Notas da equipe DelivAI sobre este cliente…',
    'dev.company.license_renewed': 'Última renovação (ISO)',
    'dev.company.license_activated': 'Licença ativada.',
    'dev.company.data_title': 'Dados da empresa',
    'dev.company.email': 'E-mail',
    'dev.company.phone': 'Telefone',
    'dev.company.company_phone': 'Telefone da empresa',
    'dev.company.owner': 'Responsável',
    'dev.company.support_email': 'E-mail de suporte',
    'dev.company.address': 'Endereço',
    'dev.company.about': 'Sobre a empresa',
    'dev.company.number': 'Número',
    'dev.company.neighborhood': 'Bairro',
    'dev.company.city': 'Cidade',
    'dev.company.state': 'UF',
    'dev.company.zip': 'CEP',
    'dev.company.active_hint': 'A conta está ligada. Entrar no painel ainda exige senha e dias de licença.',
    'dev.company.approved_hint': 'Marca interna. O cadastro nasce desmarcado e isso não impede a entrada.',
    'dev.company.license_off': 'Desativar licença',
    'dev.company.license_off_title': 'Desativar a licença?',
    'dev.company.license_off_msg': 'Escolha o que acontece com esta loja. O cadastro continua.',
    'dev.company.license_off_zero': 'Desativar e zerar os dias',
    'dev.company.license_off_access': 'Só tirar o acesso',
    'dev.company.license_off_access_done': 'Acesso desativado. Os dias ficaram guardados.',
    'dev.company.license_block': 'Bloquear temporariamente',
    'dev.company.license_block_title': 'Bloquear o acesso?',
    'dev.company.license_block_msg': 'O painel para agora. Os dias que restam ficam guardados.',
    'dev.company.license_block_for': 'Por quanto tempo?',
    'dev.company.license_block_1': '1 dia',
    'dev.company.license_block_7': '7 dias',
    'dev.company.license_block_30': '30 dias',
    'dev.company.license_block_90': '90 dias',
    'dev.company.license_unblock': 'Desbloquear',
    'dev.company.license_unblock_title': 'Desbloquear o acesso?',
    'dev.company.license_unblock_msg': 'A loja volta a entrar com os dias que ainda restam.',
    'dev.company.license_off_done': 'Licença desativada. O cadastro continua.',
    'dev.company.license_block_done': 'Acesso bloqueado. Os dias foram guardados.',
    'dev.company.license_unblock_done': 'Acesso liberado.',
    'dev.company.license_blocked_note': 'Acesso bloqueado. Os dias continuam guardados.',
    'dev.company.license_paused_title': 'Licença pausada',
    'dev.company.license_paused_hint': 'Esses dias ficam guardados e não são gastos enquanto a pausa durar.',
    'dev.company.password_set': 'Senha criada',
    'dev.company.password_missing': 'Senha ainda não criada',
    'dev.company.stage': 'Etapa',
    'dev.company.license_clause_hint': 'O contrato já permite suspender ou encerrar na hora em caso de uso ilícito. Bloquear pausa e guarda os dias. Desativar zera os dias e mantém o cadastro.',
    'license.blocked_overlay_title': 'ACESSO BLOQUEADO',
    'license.blocked_overlay_body': 'O acesso desta loja está pausado. Os dias da licença continuam guardados. Fale com a DelivAI para desbloquear.',
    'dev.licenses.save_modules': 'Salvar módulos',
    'dev.licenses.days_label': 'Dias restantes',
    'dev.licenses.save_days': 'Salvar dias',
    'dev.licenses.pay_types_label': 'pay_types (JSON deste cliente)',
    'dev.licenses.pay_types_hint':
      'O catálogo exibido a todas as lojas fica na seção global acima; aqui é o JSON específico deste CNPJ.',
    'dev.licenses.save_pay_types': 'Salvar pay_types do cliente',
    'dev.licenses.no_edit': 'Sem permissão de edição no cargo. Apenas visualização.',
    'dev.licenses.error.save_modules': 'Erro ao salvar módulos.',
    'dev.licenses.error.save_days': 'Erro ao salvar dias.',
    'dev.licenses.error.save_pay_types': 'Erro ao salvar pay_types.',
    'dev.licenses.error.save_catalog': 'Erro ao salvar catálogo global.',
    'dev.licenses.error.cnpj_invalid': 'CNPJ inválido.',
    'dev.licenses.error.not_found': 'Cliente não encontrado.',
    'dev.licenses.mod.atendimento': 'Atendimento (WhatsApp)',
    'dev.licenses.mod.atendimento_hint': 'Conversas e módulo de atendimento',
    'dev.licenses.mod.motoboy': 'Motoboy',
    'dev.licenses.mod.motoboy_hint': 'Ranking e fluxos ligados a entregadores',
    'dev.licenses.mod.gerente': 'Gerente',
    'dev.licenses.mod.gerente_hint': 'Resumo de vendas / manager',
    'dev.licenses.mod.agendamento': 'Agendamentos',
    'dev.licenses.mod.agendamento_hint': 'Agenda e integração de agendamento',
    'dev.licenses.tier.plan_name': 'Nome do plano',
    'dev.licenses.tier.days_label': 'Dias / texto',
    'dev.licenses.tier.savings': 'Nota de economia (opcional)',
    'dev.licenses.tier.pix_days': 'Dias no PIX',
    'dev.licenses.tier.pix_days_sub': 'cobrança',
    'dev.licenses.tier.amount_cents': 'Valor (centavos)',
    'dev.licenses.tier.amount_sub': 'Santander/n8n',
    'dev.licenses.tier.monthly': 'Mensal',
    'dev.licenses.tier.quarterly': 'Trimestral',
    'dev.licenses.tier.semiannual': 'Semestral',
    'dev.licenses.tier.annual': 'Anual',
    'dev.licenses.field.category': 'Nome da categoria',
    'dev.licenses.field.description': 'Descrição',
    'dev.licenses.catalog.atendimento_hint': 'Mesmo bloco que “Atendimento” na loja',
    'dev.licenses.catalog.motoboy_hint': 'Mesmo bloco que “Motoboy” na loja',
    'dev.licenses.catalog.gerente_hint': 'Mesmo bloco que “Gerente” na loja',
    'dev.licenses.catalog.agendamento_hint': 'Só no painel interno (loja não lista preços deste módulo)',
  },
  en: {
    'dev.permissions.title': 'Developer permissions',
    'dev.permissions.subtitle':
      'Register devs, lawyers, or other internal profiles. The password-link invite is sent via WhatsApp. CPF is optional — the person fills it in when accepting the invite.',
    'dev.permissions.register_section': 'Register user',
    'dev.permissions.register_btn': 'Register user',
    'dev.permissions.role_preset': 'Access profile',
    'dev.permissions.role.developer': 'Developer (full access)',
    'dev.permissions.role.lawyer': 'Lawyer (Contracts only)',
    'dev.permissions.role.custom': 'Custom (adjust permissions later)',
    'dev.permissions.cpf': 'CPF',
    'dev.permissions.cpf_hint': 'Optional. If empty, the person provides CPF when accepting the invite.',
    'dev.permissions.name': 'Full name *',
    'dev.permissions.name_placeholder': 'E.g. Maria Silva',
    'dev.permissions.email': 'Email',
    'dev.permissions.email_placeholder': 'name@company.com',
    'dev.permissions.phone': 'Phone *',
    'dev.permissions.phone_placeholder': '(11) 99999-9999',
    'dev.permissions.cancel': 'Cancel',
    'dev.permissions.no_edit_access':
      'Without "Other developers\' permissions" on your internal role — you can view the list but not register here.',
    'dev.permissions.team_section': 'Registered team ({count})',
    'dev.permissions.loading': 'Loading…',
    'dev.permissions.empty':
      'No records returned. Check n8n (get + type all) for the internal CNPJ.',
    'dev.permissions.you': 'You',
    'dev.permissions.status.active': 'Active',
    'dev.permissions.status.inactive': 'Inactive',
    'dev.permissions.role_label': 'Role:',
    'dev.permissions.edit': 'Edit permissions',
    'dev.permissions.perms': 'Permissions',
    'dev.permissions.dva_hint':
      'DelivAI Control — {count} actions mapped to sidebar tools.',
    'dev.permissions.license_ver': '{module} — view',
    'dev.permissions.default_cargo': 'DelivAI Dev',
    'dev.permissions.load_error': 'Error loading internal collaborators.',
    'dev.permissions.register_error': 'Error registering user.',
    'dev.permissions.save_error': 'Error saving permissions.',
    'dev.permissions.invite_whatsapp':
      'Hi, {name}! You were added to the DelivAI team. Use the link below to enter your CPF and create your password. This link expires in 30 minutes.\n{link}',
    'dev.permissions.invite_sender': 'DelivAI team invite (WhatsApp)',
    'dev.permissions.error.cpf_invalid_blank':
      'Invalid CPF. Enter 11 digits or leave blank for the person to fill in on invite.',
    'dev.permissions.error.cpf_invalid': 'Invalid CPF. Fix the number or leave blank.',
    'dev.permissions.error.name_required': 'Enter full name.',
    'dev.permissions.error.phone_required': 'Enter phone with area code (10 or 11 digits).',
    'dev.prompts.title': 'Bot prompts',
    'dev.prompts.subtitle':
      'One template per niche (delivery, clinic, etc.). Each store\'s name, address and menu are concatenated automatically before the AI call — do not create per-company prompts.',
    'dev.prompts.new': 'New template',
    'dev.prompts.list': 'Templates ({count})',
    'dev.prompts.list_empty': 'No records. Create one or check the n8n workflow.',
    'dev.prompts.no_edit': 'No edit permission. View only.',
    'dev.prompts.edit': 'Edit template',
    'dev.prompts.create': 'New template',
    'dev.prompts.select': 'Select a template',
    'dev.prompts.niche': 'Niche',
    'dev.prompts.niche_placeholder': 'e.g. delivery, clinic',
    'dev.prompts.niche_hint':
      'Slug shared by all stores in the same segment. E.g. workshop, delivery.',
    'dev.prompts.instructions': 'Instructions (global niche rules)',
    'dev.prompts.instructions_hint':
      'Fixed rules for the segment. Customer language and store data are injected at runtime — do not duplicate per CNPJ.',
    'dev.prompts.body': 'Prompt body (body_content)',
    'dev.prompts.version': 'Version',
    'dev.prompts.active': 'Active',
    'dev.prompts.inactive_badge': 'inactive',
    'dev.prompts.metadata': 'metadata (JSON)',
    'dev.prompts.delete': 'Delete',
    'dev.prompts.save': 'Save',
    'dev.prompts.create_btn': 'Create',
    'dev.prompts.saving': 'Saving…',
    'dev.prompts.load_error': 'Error loading templates.',
    'dev.prompts.niche_required': 'Enter niche (slug/category).',
    'dev.prompts.metadata_invalid': 'metadata must be a JSON object.',
    'dev.prompts.json_invalid': 'Invalid JSON in metadata.',
    'dev.prompts.save_error': 'Error saving.',
    'dev.prompts.delete_error': 'Error deleting.',
    'dev.prompts.created': 'Template created.',
    'dev.prompts.saved': 'Changes saved.',
    'dev.prompts.deleted': 'Template deleted.',
    'dev.prompts.delete_title': 'Delete template?',
    'dev.prompts.delete_message':
      'This removes the prompt_templates record. It cannot be undone.',
    'dev.prompts.no_nicho_label': '(no niche)',
    'dev.licenses.title': 'Licenses and customer-facing prices',
    'dev.licenses.subtitle':
      'The price catalog applies to all stores and is stored in pay_types.license_catalog on the internal CNPJ. Below, per-CNPJ adjustments affect only that client.',
    'dev.licenses.global_section': 'Global catalog (all stores)',
    'dev.licenses.global_hint':
      'Open each category to edit days and plans. Use PIX days and amount (cents) per period.',
    'dev.licenses.loading_catalog': 'Loading catalog…',
    'dev.licenses.save_global': 'Save global catalog',
    'dev.licenses.per_client_section': 'Per-client adjustment',
    'dev.licenses.per_client_hint': 'Lookup via get-customer; updates via update-customer (days, pay_types, modules).',
    'dev.licenses.cnpj_label': 'Client CNPJ',
    'dev.licenses.search': 'Search',
    'dev.licenses.loading': 'Loading…',
    'dev.licenses.client_fallback': 'Client',
    'dev.licenses.modules_section': 'License modules',
    'dev.licenses.modules_hint': 'Same boolean fields used in the sidebar and client license screen.',
    'dev.company.license_title': 'License',
    'dev.company.license_ask_days': 'Days',
    'dev.company.license_days_7': '7 days',
    'dev.company.license_days_30': '30 days',
    'dev.company.license_days_180': '180 days',
    'dev.company.license_days_365': '1 year',
    'dev.company.license_ask_modules': 'Which modules stay on?',
    'dev.company.license_continue': 'Continue',
    'dev.company.license_turn_on': 'Activate license',
    'dev.company.license_cancel': 'Cancel',
    'dev.company.license_days_invalid': 'Enter a number of days greater than zero.',
    'dev.company.license_notes': 'Internal notes',
    'dev.company.license_notes_ph': 'DelivAI team notes about this client…',
    'dev.company.license_renewed': 'Last renewal (ISO)',
    'dev.company.license_activated': 'License activated.',
    'dev.company.data_title': 'Company details',
    'dev.company.email': 'Email',
    'dev.company.phone': 'Phone',
    'dev.company.company_phone': 'Company phone',
    'dev.company.owner': 'Owner',
    'dev.company.support_email': 'Support email',
    'dev.company.address': 'Address',
    'dev.company.about': 'About the company',
    'dev.company.number': 'Number',
    'dev.company.neighborhood': 'Neighborhood',
    'dev.company.city': 'City',
    'dev.company.state': 'State',
    'dev.company.zip': 'ZIP',
    'dev.company.active_hint': 'The account is on. The panel still requires a password and license days.',
    'dev.company.approved_hint': 'Internal mark. New signups start unchecked, and this does not block sign-in.',
    'dev.company.license_off': 'Turn license off',
    'dev.company.license_off_title': 'Turn the license off?',
    'dev.company.license_off_msg': 'Choose what happens to this store. The record stays.',
    'dev.company.license_off_zero': 'Turn off and clear the days',
    'dev.company.license_off_access': 'Only remove access',
    'dev.company.license_off_access_done': 'Access turned off. The days were kept.',
    'dev.company.license_block': 'Block for now',
    'dev.company.license_block_title': 'Block access?',
    'dev.company.license_block_msg': 'The panel stops now. Remaining days stay saved.',
    'dev.company.license_block_for': 'For how long?',
    'dev.company.license_block_1': '1 day',
    'dev.company.license_block_7': '7 days',
    'dev.company.license_block_30': '30 days',
    'dev.company.license_block_90': '90 days',
    'dev.company.license_unblock': 'Unblock',
    'dev.company.license_unblock_title': 'Unblock access?',
    'dev.company.license_unblock_msg': 'The store can sign in again with the days still left.',
    'dev.company.license_off_done': 'License turned off. The record stays.',
    'dev.company.license_block_done': 'Access blocked. The days were kept.',
    'dev.company.license_unblock_done': 'Access restored.',
    'dev.company.license_blocked_note': 'Access is blocked. The days are still saved.',
    'dev.company.license_paused_title': 'License paused',
    'dev.company.license_paused_hint': 'These days stay saved and are not spent while the pause lasts.',
    'dev.company.password_set': 'Password created',
    'dev.company.password_missing': 'Password not created yet',
    'dev.company.stage': 'Stage',
    'dev.company.license_clause_hint': 'The contract already allows an immediate suspension if the use is unlawful. Block pauses and keeps the days. Turn off clears the days and keeps the record.',
    'license.blocked_overlay_title': 'ACCESS BLOCKED',
    'license.blocked_overlay_body': 'This store is paused. The license days are still saved. Contact DelivAI to restore access.',
    'dev.licenses.save_modules': 'Save modules',
    'dev.licenses.days_label': 'Days remaining',
    'dev.licenses.save_days': 'Save days',
    'dev.licenses.pay_types_label': 'pay_types (this client JSON)',
    'dev.licenses.pay_types_hint':
      'The catalog shown to all stores is in the global section above; this is this CNPJ-specific JSON.',
    'dev.licenses.save_pay_types': 'Save client pay_types',
    'dev.licenses.no_edit': 'No edit permission on your role. View only.',
    'dev.licenses.error.save_modules': 'Error saving modules.',
    'dev.licenses.error.save_days': 'Error saving days.',
    'dev.licenses.error.save_pay_types': 'Error saving pay_types.',
    'dev.licenses.error.save_catalog': 'Error saving global catalog.',
    'dev.licenses.error.cnpj_invalid': 'Invalid CNPJ.',
    'dev.licenses.error.not_found': 'Client not found.',
    'dev.licenses.mod.atendimento': 'Support (WhatsApp)',
    'dev.licenses.mod.atendimento_hint': 'Conversations and support module',
    'dev.licenses.mod.motoboy': 'Courier',
    'dev.licenses.mod.motoboy_hint': 'Ranking and courier flows',
    'dev.licenses.mod.gerente': 'Manager',
    'dev.licenses.mod.gerente_hint': 'Sales summary / manager',
    'dev.licenses.mod.agendamento': 'Appointments',
    'dev.licenses.mod.agendamento_hint': 'Schedule and appointment integration',
    'dev.licenses.tier.plan_name': 'Plan name',
    'dev.licenses.tier.days_label': 'Days / label',
    'dev.licenses.tier.savings': 'Savings note (optional)',
    'dev.licenses.tier.pix_days': 'PIX days',
    'dev.licenses.tier.pix_days_sub': 'billing',
    'dev.licenses.tier.amount_cents': 'Amount (cents)',
    'dev.licenses.tier.amount_sub': 'Santander/n8n',
    'dev.licenses.tier.monthly': 'Monthly',
    'dev.licenses.tier.quarterly': 'Quarterly',
    'dev.licenses.tier.semiannual': 'Semi-annual',
    'dev.licenses.tier.annual': 'Annual',
    'dev.licenses.field.category': 'Category name',
    'dev.licenses.field.description': 'Description',
    'dev.licenses.catalog.atendimento_hint': 'Same block as “Support” in the store',
    'dev.licenses.catalog.motoboy_hint': 'Same block as “Courier” in the store',
    'dev.licenses.catalog.gerente_hint': 'Same block as “Manager” in the store',
    'dev.licenses.catalog.agendamento_hint': 'Internal panel only (store does not list this module pricing)',
  },
  es: {
    'dev.permissions.title': 'Permisos de desarrolladores',
    'dev.permissions.subtitle':
      'Registre devs, abogados u otros perfiles internos. La invitación con enlace de contraseña se envía por WhatsApp. CPF es opcional — la persona lo completa al aceptar la invitación.',
    'dev.permissions.register_section': 'Registrar usuario',
    'dev.permissions.register_btn': 'Registrar usuario',
    'dev.permissions.role_preset': 'Perfil de acceso',
    'dev.permissions.role.developer': 'Desarrollador (acceso completo)',
    'dev.permissions.role.lawyer': 'Abogado (solo Contratos)',
    'dev.permissions.role.custom': 'Personalizado (ajustar permisos después)',
    'dev.permissions.cpf': 'CPF',
    'dev.permissions.cpf_hint': 'Opcional. Si está vacío, la persona informa el CPF al aceptar la invitación.',
    'dev.permissions.name': 'Nombre completo *',
    'dev.permissions.name_placeholder': 'Ej.: Maria Silva',
    'dev.permissions.email': 'Correo',
    'dev.permissions.email_placeholder': 'nombre@empresa.com',
    'dev.permissions.phone': 'Teléfono *',
    'dev.permissions.phone_placeholder': '(11) 99999-9999',
    'dev.permissions.cancel': 'Cancelar',
    'dev.permissions.no_edit_access':
      'Sin la acción "Permisos de otros desarrolladores" en su cargo interno — puede ver la lista pero no registrar aquí.',
    'dev.permissions.team_section': 'Equipo registrado ({count})',
    'dev.permissions.loading': 'Cargando…',
    'dev.permissions.empty':
      'Ningún registro devuelto. Revise n8n (get + type all) para el CNPJ interno.',
    'dev.permissions.you': 'Usted',
    'dev.permissions.status.active': 'Activo',
    'dev.permissions.status.inactive': 'Inactivo',
    'dev.permissions.role_label': 'Función:',
    'dev.permissions.edit': 'Editar permisos',
    'dev.permissions.perms': 'Permisos',
    'dev.permissions.dva_hint':
      'Control DelivAI — {count} acciones mapeadas a las herramientas del menú lateral.',
    'dev.permissions.license_ver': '{module} — ver',
    'dev.permissions.default_cargo': 'Dev DelivAI',
    'dev.permissions.load_error': 'Error al cargar colaboradores internos.',
    'dev.permissions.register_error': 'Error al registrar.',
    'dev.permissions.save_error': 'Error al guardar permisos.',
    'dev.permissions.invite_whatsapp':
      'Hola, {name}! Fuiste registrado(a) en el equipo DelivAI. Accede al enlace abajo para informar tu CPF y crear tu contraseña. Este enlace expira en 30 minutos.\n{link}',
    'dev.permissions.invite_sender': 'Invitación equipo DelivAI (WhatsApp)',
    'dev.permissions.error.cpf_invalid_blank':
      'CPF inválido. Ingrese 11 dígitos o déjelo en blanco para que la persona lo complete en la invitación.',
    'dev.permissions.error.cpf_invalid': 'CPF inválido. Corrija el número o déjelo en blanco.',
    'dev.permissions.error.name_required': 'Ingrese el nombre completo.',
    'dev.permissions.error.phone_required': 'Ingrese el teléfono con DDD (10 u 11 dígitos).',
    'dev.prompts.title': 'Prompts del bot',
    'dev.prompts.subtitle':
      'Un template por nicho (delivery, clínica, etc.). Nombre, dirección y menú de cada tienda se concatenan automáticamente antes de la IA — no cree prompt por empresa.',
    'dev.prompts.new': 'Nuevo template',
    'dev.prompts.list': 'Templates ({count})',
    'dev.prompts.list_empty': 'Sin registros. Cree uno o revise el workflow n8n.',
    'dev.prompts.no_edit': 'Sin permiso de edición. Solo visualización.',
    'dev.prompts.edit': 'Editar template',
    'dev.prompts.create': 'Nuevo template',
    'dev.prompts.select': 'Seleccione un template',
    'dev.prompts.niche': 'Nicho',
    'dev.prompts.niche_placeholder': 'ej.: delivery, clinica',
    'dev.prompts.niche_hint':
      'Slug compartido por todas las tiendas del mismo segmento. Ej.: taller, delivery.',
    'dev.prompts.instructions': 'Instrucciones (reglas globales del nicho)',
    'dev.prompts.instructions_hint':
      'Reglas fijas del segmento. Idioma del cliente y datos de la tienda se inyectan en runtime — no duplique por CNPJ.',
    'dev.prompts.body': 'Cuerpo del prompt (body_content)',
    'dev.prompts.version': 'Versión',
    'dev.prompts.active': 'Activo',
    'dev.prompts.inactive_badge': 'inactivo',
    'dev.prompts.metadata': 'metadata (JSON)',
    'dev.prompts.delete': 'Eliminar',
    'dev.prompts.save': 'Guardar',
    'dev.prompts.create_btn': 'Crear',
    'dev.prompts.saving': 'Guardando…',
    'dev.prompts.load_error': 'Error al cargar templates.',
    'dev.prompts.niche_required': 'Ingrese el nicho (slug/categoría).',
    'dev.prompts.metadata_invalid': 'metadata debe ser un objeto JSON.',
    'dev.prompts.json_invalid': 'JSON inválido en metadata.',
    'dev.prompts.save_error': 'Error al guardar.',
    'dev.prompts.delete_error': 'Error al eliminar.',
    'dev.prompts.created': 'Template creado.',
    'dev.prompts.saved': 'Cambios guardados.',
    'dev.prompts.deleted': 'Template eliminado.',
    'dev.prompts.delete_title': '¿Eliminar template?',
    'dev.prompts.delete_message':
      'Esta acción elimina el registro en prompt_templates. No se puede deshacer.',
    'dev.prompts.no_nicho_label': '(sin nicho)',
    'dev.licenses.title': 'Licencias y valores mostrados al cliente',
    'dev.licenses.subtitle':
      'El catálogo de precios aplica a todas las tiendas y se guarda en pay_types.license_catalog del CNPJ interno. Abajo, el ajuste por CNPJ afecta solo a ese cliente.',
    'dev.licenses.global_section': 'Catálogo global (todas las tiendas)',
    'dev.licenses.global_hint':
      'Abra cada categoría para editar días y planes. Use Días en PIX y Valor (centavos) por período.',
    'dev.licenses.loading_catalog': 'Cargando catálogo…',
    'dev.licenses.save_global': 'Guardar catálogo global',
    'dev.licenses.per_client_section': 'Ajuste por cliente',
    'dev.licenses.per_client_hint': 'Consulta vía get-customer; cambios vía update-customer (días, pay_types, módulos).',
    'dev.licenses.cnpj_label': 'CNPJ del cliente',
    'dev.licenses.search': 'Buscar',
    'dev.licenses.loading': 'Cargando…',
    'dev.licenses.client_fallback': 'Cliente',
    'dev.licenses.modules_section': 'Módulos de licencia',
    'dev.licenses.modules_hint': 'Mismos campos booleanos usados en la sidebar y pantalla de licencia del cliente.',
    'dev.company.license_title': 'Licencia',
    'dev.company.license_ask_days': 'Días',
    'dev.company.license_days_7': '7 días',
    'dev.company.license_days_30': '30 días',
    'dev.company.license_days_180': '180 días',
    'dev.company.license_days_365': '1 año',
    'dev.company.license_ask_modules': '¿Qué módulos quedan activos?',
    'dev.company.license_continue': 'Continuar',
    'dev.company.license_turn_on': 'Activar licencia',
    'dev.company.license_cancel': 'Cancelar',
    'dev.company.license_days_invalid': 'Indique un número de días mayor que cero.',
    'dev.company.license_notes': 'Observaciones internas',
    'dev.company.license_notes_ph': 'Notas del equipo DelivAI sobre este cliente…',
    'dev.company.license_renewed': 'Última renovación (ISO)',
    'dev.company.license_activated': 'Licencia activada.',
    'dev.company.data_title': 'Datos de la empresa',
    'dev.company.email': 'Correo',
    'dev.company.phone': 'Teléfono',
    'dev.company.company_phone': 'Teléfono de la empresa',
    'dev.company.owner': 'Responsable',
    'dev.company.support_email': 'Correo de soporte',
    'dev.company.address': 'Dirección',
    'dev.company.about': 'Sobre la empresa',
    'dev.company.number': 'Número',
    'dev.company.neighborhood': 'Barrio',
    'dev.company.city': 'Ciudad',
    'dev.company.state': 'UF',
    'dev.company.zip': 'CP',
    'dev.company.active_hint': 'La cuenta está encendida. Entrar al panel sigue exigiendo contraseña y días de licencia.',
    'dev.company.approved_hint': 'Marca interna. El alta nace desmarcada y esto no impide el acceso.',
    'dev.company.license_off': 'Desactivar licencia',
    'dev.company.license_off_title': '¿Desactivar la licencia?',
    'dev.company.license_off_msg': 'Elija qué pasa con esta tienda. El registro sigue.',
    'dev.company.license_off_zero': 'Desactivar y poner los días en cero',
    'dev.company.license_off_access': 'Solo quitar el acceso',
    'dev.company.license_off_access_done': 'Acceso desactivado. Los días se guardaron.',
    'dev.company.license_block': 'Bloquear por ahora',
    'dev.company.license_block_title': '¿Bloquear el acceso?',
    'dev.company.license_block_msg': 'El panel se detiene ahora. Los días que quedan se guardan.',
    'dev.company.license_block_for': '¿Por cuánto tiempo?',
    'dev.company.license_block_1': '1 día',
    'dev.company.license_block_7': '7 días',
    'dev.company.license_block_30': '30 días',
    'dev.company.license_block_90': '90 días',
    'dev.company.license_unblock': 'Desbloquear',
    'dev.company.license_unblock_title': '¿Desbloquear el acceso?',
    'dev.company.license_unblock_msg': 'La tienda vuelve a entrar con los días que aún quedan.',
    'dev.company.license_off_done': 'Licencia desactivada. El registro sigue.',
    'dev.company.license_block_done': 'Acceso bloqueado. Los días se guardaron.',
    'dev.company.license_unblock_done': 'Acceso liberado.',
    'dev.company.license_blocked_note': 'Acceso bloqueado. Los días siguen guardados.',
    'dev.company.license_paused_title': 'Licencia en pausa',
    'dev.company.license_paused_hint': 'Esos días quedan guardados y no se gastan mientras dure la pausa.',
    'dev.company.password_set': 'Contraseña creada',
    'dev.company.password_missing': 'Contraseña aún no creada',
    'dev.company.stage': 'Etapa',
    'dev.company.license_clause_hint': 'El contrato ya permite suspender o cerrar de inmediato si el uso es ilícito. Bloquear pausa y guarda los días. Desactivar pone los días en cero y mantiene el registro.',
    'license.blocked_overlay_title': 'ACCESO BLOQUEADO',
    'license.blocked_overlay_body': 'El acceso de esta tienda está en pausa. Los días de la licencia siguen guardados. Hable con DelivAI para desbloquear.',
    'dev.licenses.save_modules': 'Guardar módulos',
    'dev.licenses.days_label': 'Días restantes',
    'dev.licenses.save_days': 'Guardar días',
    'dev.licenses.pay_types_label': 'pay_types (JSON de este cliente)',
    'dev.licenses.pay_types_hint':
      'El catálogo mostrado a todas las tiendas está en la sección global; aquí va el JSON específico de este CNPJ.',
    'dev.licenses.save_pay_types': 'Guardar pay_types del cliente',
    'dev.licenses.no_edit': 'Sin permiso de edición en el cargo. Solo visualización.',
    'dev.licenses.error.save_modules': 'Error al guardar módulos.',
    'dev.licenses.error.save_days': 'Error al guardar días.',
    'dev.licenses.error.save_pay_types': 'Error al guardar pay_types.',
    'dev.licenses.error.save_catalog': 'Error al guardar catálogo global.',
    'dev.licenses.error.cnpj_invalid': 'CNPJ inválido.',
    'dev.licenses.error.not_found': 'Cliente no encontrado.',
    'dev.licenses.mod.atendimento': 'Atención (WhatsApp)',
    'dev.licenses.mod.atendimento_hint': 'Conversaciones y módulo de atención',
    'dev.licenses.mod.motoboy': 'Repartidor',
    'dev.licenses.mod.motoboy_hint': 'Ranking y flujos de repartidores',
    'dev.licenses.mod.gerente': 'Gerente',
    'dev.licenses.mod.gerente_hint': 'Resumen de ventas / manager',
    'dev.licenses.mod.agendamento': 'Citas',
    'dev.licenses.mod.agendamento_hint': 'Agenda e integración de citas',
    'dev.licenses.tier.plan_name': 'Nombre del plan',
    'dev.licenses.tier.days_label': 'Días / texto',
    'dev.licenses.tier.savings': 'Nota de ahorro (opcional)',
    'dev.licenses.tier.pix_days': 'Días en PIX',
    'dev.licenses.tier.pix_days_sub': 'cobro',
    'dev.licenses.tier.amount_cents': 'Valor (centavos)',
    'dev.licenses.tier.amount_sub': 'Santander/n8n',
    'dev.licenses.tier.monthly': 'Mensual',
    'dev.licenses.tier.quarterly': 'Trimestral',
    'dev.licenses.tier.semiannual': 'Semestral',
    'dev.licenses.tier.annual': 'Anual',
    'dev.licenses.field.category': 'Nombre de categoría',
    'dev.licenses.field.description': 'Descripción',
    'dev.licenses.catalog.atendimento_hint': 'Mismo bloque que “Atención” en la tienda',
    'dev.licenses.catalog.motoboy_hint': 'Mismo bloque que “Repartidor” en la tienda',
    'dev.licenses.catalog.gerente_hint': 'Mismo bloque que “Gerente” en la tienda',
    'dev.licenses.catalog.agendamento_hint': 'Solo panel interno (la tienda no lista precios de este módulo)',
  },
} as const;
